var map = {
	"./GB/VictimSupport.png": 79376,
	"./GB/childline.png": 75476,
	"./GB/cps.svg": 55645,
	"./GB/mind.png": 69093,
	"./GB/refuge.png": 98439,
	"./GB/respect.png": 21350,
	"./GB/samaritans.png": 90543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25071;